import { cn } from '@/core/utils/cn';

type LinkieLogoProps = {
  className?: string;
};

/**
 * The Linkie lockup, inlined so it can follow the surface it sits on: the
 * wordmark and the pin body use `currentColor` (set it with a text colour —
 * `text-lighter` resolves to near-white on dark themes and deep navy on light
 * ones) while the brand cyan stays fixed.
 */
const LinkieLogo = ({ className }: LinkieLogoProps) => (
  <svg
    viewBox="0 0 1164 359.4"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Linkie"
    className={cn('w-40 h-auto', className)}
  >
    <g>
      <g>
        <g>
          <polyline fill="#30BCE2" points="199.4,131.6 158.1,145.1 144.4,184.4 186.2,169.8       " />
          <path
            fill="#30BCE2"
            d="M229,292.3l48-138.1c-0.5,1.2-1,2.4-1.6,3.6c-6.7,13.9-18.4,24.3-33,29.3l-15.5,5.4l-30.7,88.4
            c-4.1,11.9-17.2,18.3-29.2,14.1l0,0c-11.9-4.2-18.3-17.2-14.1-29.2l18.8-54.2l-41.8,14.5l-9.8,28.3c-7.5,21.5-1.4,44.6,13.8,59.7
            c6,6,13.3,10.7,21.8,13.6l0,0C185.6,338.2,218.5,322.3,229,292.3z"
          />
          <path
            fill="currentColor"
            d="M90.2,203.2c-11.9,4.1-25-2.2-29.2-14.1l0,0c-4.1-11.9,2.2-25,14.1-29.2l88.4-30.7l5.4-15.5
            c5.1-14.5,15.5-26.2,29.3-33c1.2-0.6,2.4-1.1,3.6-1.6l-138.1,48c-30,10.4-46,43.3-35.5,73.4l0,0c2.9,8.5,7.7,15.8,13.6,21.8
            c15.1,15.1,38.2,21.2,59.7,13.8l28.3-9.8l14.5-41.8L90.2,203.2z"
          />
          <polygon fill="#30BCE2" points="186.2,169.8 144.4,184.4 129.9,226.2 171.7,211.6       " />
          <path
            fill="currentColor"
            d="M169,113.6l-5.4,15.5l50.9-17.7c5.3-2.2,11.1-2.5,16.5-0.6c2.3,0.8,4.5,2,6.4,3.4c0.1,0,0.1,0.1,0.2,0.2
            c0.5,0.4,1,0.8,1.4,1.2c0.3,0.2,0.5,0.5,0.7,0.7c0.2,0.2,0.5,0.5,0.7,0.7c0.4,0.5,0.8,0.9,1.2,1.4c0.1,0.1,0.1,0.1,0.2,0.2
            c1.4,1.9,2.6,4,3.4,6.4c1.9,5.4,1.7,11.2-0.6,16.5l-17.7,50.9l15.5-5.4c14.5-5.1,26.2-15.5,33-29.3c0.6-1.2,1.1-2.4,1.6-3.6
            l0.9-2.7c5.1-14.5,4.1-30.2-2.6-44c-2.1-4.3-4.7-8.3-7.7-11.9c0,0-0.1-0.1-0.1-0.1c-0.5-0.6-1-1.2-1.6-1.8
            c-0.2-0.2-0.4-0.4-0.6-0.6c-0.4-0.4-0.8-0.8-1.1-1.2c-0.4-0.4-0.8-0.8-1.2-1.1c-0.2-0.2-0.4-0.4-0.6-0.6
            c-0.6-0.5-1.2-1.1-1.8-1.6c0,0-0.1-0.1-0.1-0.1c-3.6-3-7.6-5.6-11.9-7.7c-13.9-6.7-29.5-7.6-44-2.6l-2.7,0.9
            c-1.2,0.5-2.4,1-3.6,1.6C184.5,87.4,174.1,99.1,169,113.6z"
          />
          <g>
            <path
              fill="currentColor"
              d="M244.1,142.6c-2.7,5.5-7.3,9.7-13.1,11.7l-31.1,10.8L187,206.3l39.9-13.9l17.7-50.9
              C244.4,141.9,244.3,142.3,244.1,142.6z"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#30BCE2"
                  d="M292,67.8L292,67.8c-1.8-1.8-1.8-4.6,0-6.4l9.7-9.7c1.8-1.8,4.6-1.8,6.4,0l0,0c1.8,1.8,1.8,4.6,0,6.4
                  l-9.7,9.7C296.6,69.6,293.7,69.6,292,67.8z"
                />
              </g>
              <g>
                <g>
                  <path
                    fill="#30BCE2"
                    d="M222,42.1L222,42.1c1.8-1.8,4.6-1.8,6.4,0l9.7,9.7c1.8,1.8,1.8,4.6,0,6.4v0c-1.8,1.8-4.6,1.8-6.4,0
                    l-9.7-9.7C220.3,46.7,220.3,43.9,222,42.1z"
                  />
                </g>
                <g>
                  <path
                    fill="#30BCE2"
                    d="M264.2,30.6L264.2,30.6c-2.5,0-4.5,2-4.5,4.5v13.6c0,2.5,2,4.5,4.5,4.5l0,0c2.5,0,4.5-2,4.5-4.5l0-13.6
                    C268.7,32.6,266.7,30.6,264.2,30.6z"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    fill="#30BCE2"
                    d="M317.7,137.8L317.7,137.8c1.8-1.8,1.8-4.6,0-6.4l-9.7-9.7c-1.8-1.8-4.6-1.8-6.4,0l0,0
                    c-1.8,1.8-1.8,4.6,0,6.4l9.7,9.7C313.1,139.5,315.9,139.5,317.7,137.8z"
                  />
                </g>
                <g>
                  <path
                    fill="#30BCE2"
                    d="M329.2,95.6L329.2,95.6c0,2.5-2,4.5-4.5,4.5H311c-2.5,0-4.5-2-4.5-4.5v0c0-2.5,2-4.5,4.5-4.5h13.6
                    C327.2,91.1,329.2,93.2,329.2,95.6z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <path
      fill="currentColor"
      d="M367.6,296.1V115.5c0-10.4,8.4-18.8,18.8-18.8h22.4v164.3h83.5v10.4c0,13.6-11,24.7-24.7,24.7H367.6z"
    />
    <path
      fill="currentColor"
      d="M519.4,115V80.8h24.7c8.1,0,14.7,6.6,14.7,14.7V115H519.4z M520,296.1V148.3h38.5v147.8H520z"
    />
    <path
      fill="currentColor"
      d="M599.7,296.1V148.3h35.6l1.2,18.5h2.6c2.5-4.8,5.8-8.8,9.9-11.9c4.1-3.1,9-5.4,14.9-6.8
      c5.9-1.4,12.6-2.2,20.1-2.2c10,0,18.1,1.3,24.2,3.8c6.1,2.5,10.8,6.2,14.1,11c3.3,4.8,5.5,10.8,6.5,18c1.1,7.2,1.6,15.5,1.6,24.9
      v92.4h-38.3v-78.2c0-9.1-0.3-16.2-0.9-21.3c-0.6-5.1-1.7-8.9-3.3-11.3c-1.6-2.4-4.3-4-7.8-4.8c-3.6-0.8-8.3-1.2-14.1-1.2
      c-6.2,0-11.2,0.7-15.1,2.2c-3.9,1.4-6.7,3.8-8.4,7.1c-1.7,3.3-2.9,7.4-3.6,12.5c-0.7,5-1,11.2-1,18.5v76.5H599.7z"
    />
    <path
      fill="currentColor"
      d="M771.5,296.1V80.8h33c2.9,0,5.2,2.3,5.2,5.2v120.5H822l40.6-55.4c1.3-1.8,3.3-2.8,5.5-2.8h38.3l-53.3,71
      l54.2,76.8h-40c-2.2,0-4.2-1-5.5-2.8L822,237.6h-12.2v58.5H771.5z"
    />
    <path
      fill="currentColor"
      d="M932.7,115V80.8H956c8.9,0,16.1,7.2,16.1,16.1V115H932.7z M933.3,296.1V148.3h38.5v147.8H933.3z"
    />
    <path
      fill="currentColor"
      d="M1097.9,297.9c-6.8,0.4-13.1,0.6-19.1,0.6c-13.1,0-24.1-0.9-32.7-2.6c-8.7-1.7-15.6-4.5-20.7-8.3
      c-5.1-3.8-8.9-8.6-11.4-14.5c-2.5-5.9-4.2-13-4.9-21.4c-0.8-8.4-1.2-18.1-1.2-29.1c0-13.1,0.7-24.5,2-34.2
      c1.3-9.7,4.2-17.7,8.5-24.1c4.3-6.4,11.1-11,20.3-13.9c9.2-2.9,21.4-4.3,36.7-4.3c12.4,0,22.4,0.9,30.1,2.8
      c7.7,1.8,13.9,4.7,18.4,8.7c4.5,4,7.8,8.9,9.9,14.9c2,6,3.3,13.2,3.9,21.6c0.6,8.4,0.9,17.9,0.9,28.5v11.3H1046c0,7.5,0.3,13.5,1,18
      c0.7,4.4,2.3,7.9,4.9,10.3c2.6,2.4,6.8,4,12.5,4.6c5.7,0.7,13.5,1,23.3,1c4.1,0,8.6,0,13.8-0.1c5.1-0.1,10.4-0.4,15.9-1
      c5.5-0.6,10.6-1.1,15.2-1.4v10.1c0,10.8-8.2,19.9-18.9,21C1105.6,297.1,1097.9,297.9,1097.9,297.9z M1101.9,214.4v-4.3
      c0-7.5-0.4-13.6-1.3-18.1c-0.9-4.5-2.3-7.9-4.3-10.1c-2-2.2-4.8-3.7-8.4-4.5c-3.6-0.8-7.9-1.2-12.9-1.2c-6.6,0-11.7,0.4-15.5,1.3
      c-3.8,0.9-6.6,2.5-8.4,4.9c-1.8,2.4-3.1,5.9-3.9,10.4c-0.8,4.5-1.2,10.4-1.2,17.5h61.1L1101.9,214.4z"
    />
    <path fill="#30BCE2" d="M519.5,115.1V80.9h25c7.9,0,14.4,6.4,14.4,14.4v19.8H519.5z" />
    <path fill="#30BCE2" d="M932.7,115V80.8h25c7.9,0,14.4,6.4,14.4,14.4V115H932.7z" />
  </svg>
);

export default LinkieLogo;
